import React from "react";
import { Link } from "react-router-dom";

const messages = [
  "Reticulating splines...",
  "Oops! The bots ate this page.",
  "The requested page is in another castle.",
  "Calculating the meaning of life...",
  "Whoops!",
  "This page went to refill its coffee.",
  "We got lost. Send snacks.",
  "We forgot to pay the server bill, sorry!",
  "Sorry, this page has gone to Narnia.",
  "Plot twist: There was never a page here!",
  "🍰 The page is a lie.",
  "We're not sure what you're looking for, but it's not here.",
  "We asked ChatGPT. It said: 'Page not found.'",
  "Our homing pigeons couldn't find this one, either.",
  "This isn’t the page you’re looking for.",
  "Your page is in another dimension, try again later.",
  "Congratulations! You're the 10,000th person to find this page.",
];

function getRandomMessage() {
  return messages[Math.floor(Math.random() * messages.length)];
}

const NotFound = () => {
  const [line] = React.useState(getRandomMessage());
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-900 px-4">
      <div className="text-center">
        <p className="text-6xl font-bold text-gray-600">404</p>
        <p className="mt-2 max-w-md text-gray-400">{line}</p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-md bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700"
        >
          Go home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
